// // src/components/AuthProvider.js
// import { useEffect } from 'react';
// import { useDispatch } from 'react-redux';
// import memberstack from '../memberstack';
// import { setUser } from '../actions/user';

// const AuthProvider = ({ children }) => {
//   const dispatch = useDispatch();

//   useEffect(() => {
//     // Check for the current member on mount
//     memberstack.getCurrentMember()
//       .then(({ data}) => {
//         // console.log("getCurrentMember response:", data);
//         dispatch(setUser(data));
//       })
//       .catch((error) => {
//         console.error("Error fetching member:", error);
//       });

//     // Subscribe to auth changes
//     const authListener = memberstack.onAuthChange((data) => {
//       dispatch(setUser(data));
//       memberstack.hideModal();
//     });

//     // Cleanup on unmount
//     return () => authListener.unsubscribe();
//   }, [dispatch]);

//   return children;
// };

// export default AuthProvider;


import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import memberstack from '../memberstack';
import { setUser } from '../actions/user';
import { fetchAccess } from '../actions/access';
import { ACCESS_RESET } from '../constants/actionTypes';

const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    memberstack.getCurrentMember()
      .then(({ data }) => {
        dispatch(setUser(data));

        if (data?.id) {
          dispatch(fetchAccess());
        } else {
          dispatch({ type: ACCESS_RESET });
        }
      })
      .catch(() => {
        dispatch({ type: ACCESS_RESET });
      });

    const authListener = memberstack.onAuthChange((data) => {
      dispatch(setUser(data));

      if (data?.id) {
        dispatch(fetchAccess());
      } else {
        dispatch({ type: ACCESS_RESET });
      }

      memberstack.hideModal();
    });

    return () => authListener.unsubscribe();
  }, [dispatch]);

  return children;
};

export default AuthProvider;
